import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext, useRef } from 'react';
import { useUserId, useUserLocation } from '~/context/common/UserContext';
import UserVehicleContext, {
  defaultAvailability
} from '~/context/vdp/UserVehicleContext';
import {
  useGetVehicleDetails,
  useGetVehicleId
} from '~/context/vdp/VehicleContext';
import fetchUserVehicleAvailability from '~/services/vdp/fetchVehicleAvailability';
import { generateErrorLogger } from '~/utilities/loggers';
import transformAvailability from '~/utilities/vdp/transformAvailability';

export default function useGetVehicleAvailability() {
  const {
    fetchVehicleAvailabilityFlag,
    fetchedVehicleAvailabilityOnServer,
    vehicleAvailability: { setData, setError, setLoading }
  } = useContext(UserVehicleContext);
  const vehicleId = useGetVehicleId();
  const userId = useUserId();
  const { zip } = useUserLocation();
  const { saleStatus } = useGetVehicleDetails();

  const isFirstRenderAndFetchedOnServer = useRef(
    fetchedVehicleAvailabilityOnServer
  );

  useEffectWithController(
    controller => {
      // Skip initial fetch if server already fetched
      if (isFirstRenderAndFetchedOnServer.current) {
        isFirstRenderAndFetchedOnServer.current = false;

        return;
      }

      if (saleStatus === 'Sold') {
        setData(defaultAvailability);

        return;
      }

      if (!zip) return;

      setLoading();

      fetchUserVehicleAvailability(
        {
          userId,
          vehicleId,
          zip
        },
        controller
      )
        .then(res => setData(transformAvailability(res)))
        .catch(
          generateErrorLogger(
            'Get vehicle availability',
            {},
            { callback: setError, controller }
          )
        );
    },
    [
      fetchVehicleAvailabilityFlag,
      saleStatus,
      setData,
      setError,
      setLoading,
      userId,
      vehicleId,
      zip
    ]
  );
}
